<script lang="ts">
  import Button from './components/button.svelte';

  export let screenshot: string;
  export let onClose: () => void;
</script>

<svelte:window
  on:keydown={e => {
    if (e.key == 'Escape') onClose();
  }}
/>

<section>
  <figure>
    <img src={screenshot} alt="Screenshot preview" />
  </figure>

  <nav>
    <Button on:click={() => onClose()}>
      <div style="padding: 0px 10px">Close</div>
    </Button>
  </nav>
</section>

<style>
  figure {
    display: flex;
    height: 150px;
    overflow: hidden;
    border-radius: 10px;
    border: var(--loop-textareaBorder) solid 1px;
    margin: 0px;
    padding: 0px;
    background: var(--loop-textareaBackground);
    position: relative;
    height: 100%;
  }

  img {
    height: 100%;
    width: auto;
    object-fit: contain;
    display: block;
    margin: 0px auto;
    max-width: 100%;
  }

  section {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: rgba(0, 0, 0, 0.2);
    padding: 20px;
    z-index: 999999;
  }

  nav {
    position: absolute;
    top: 40px;
    right: 40px;
  }
</style>
